import TwoFactorMain from "../../components/TwoFactor/TwoFactorMain"
import Setup from "../../components/UI/Setup"

const TwoFactor = () => {
    return(
       <TwoFactorMain />
    )
}

export default TwoFactor